import { Icon, IconProps } from '@chakra-ui/react'

export default function OccurrenceIcon(props: IconProps) {
  return (
    <Icon
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color={'#868E96'}
      {...props}
    >
      <path
        d="M5 15.5h1.667M15 7.167h-1.667l-1.111 1.666L10.74 5.5 9.629 7.167H5M5 11.333h1.76l.833-1.25 1.11 2.5.834-1.25H15"
        stroke="currentColor"
        strokeWidth={1.25}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        clipRule="evenodd"
        d="M2.5 4.667v11.666c0 .921.746 1.667 1.667 1.667h11.666c.921 0 1.667-.746 1.667-1.667V4.667C17.5 3.746 16.754 3 15.833 3H4.167C3.246 3 2.5 3.746 2.5 4.667z"
        stroke="currentColor"
        strokeWidth={1.25}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  )
}
